var map = {
	"./svg/day/logo.svg": 209,
	"./svg/day/marker.svg": 121,
	"./svg/day/marker_active.svg": 122,
	"./svg/day/position.svg": 210,
	"./svg/gps.svg": 211,
	"./svg/headphones.svg": 212,
	"./svg/logo_coop.svg": 123,
	"./svg/night/logo.svg": 124,
	"./svg/night/marker.svg": 125,
	"./svg/night/marker_active.svg": 126,
	"./svg/night/position.svg": 213,
	"./svg/phone.svg": 214,
	"./svg/texture.svg": 120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;